import React from "react";
import Head from "../../Global/Head";
import Header from "../../Global/Header";

const DetailsPageSkeliton = () => {
  return (
    <div>
      <div className="hidden md:inline">
        <Head />
        <Header />
      </div>

      <ul className="mt-5 space-y-3 -ml-8 md:-ml-0">
        <li className="w-56 h-4 bg-gray-200 rounded-full"></li>
        <li className="w-full mr-20 h-4 bg-gray-200 rounded-full mt-5"></li>
      </ul>
      <figure className="card listing-details-page">
        <div className="swiper-card-div">
          <div className="card-top-back-share"></div>
          <div className="swiper-slide-content">
            <div className="category-div"></div>
            <div className="table-heading-featured"></div>
          </div>
          <div
            sizes="(max-width: 479px) 92vw, (max-width: 767px) 95vw, (max-width: 991px) 94vw, 100vw"
            alt="Hightable-table-hosted"
            loading="lazy"
            className="card__bg bg-gray-200"
          />
        </div>
      </figure>
      <div className="home-header_grid">
        <div
          id="w-node-_817f4cfa-d017-709f-9415-15299ace61da-a79a8c84"
          className="header-image-block"
        >
          <div
            sizes="(max-width: 991px) 100vw, (max-width: 1279px) 91vw, (max-width: 1439px) 92vw, (max-width: 1919px) 94vw, 97vw"
            alt=""
            loading="lazy"
            className="header-image-2 placeholderimg bg-gray-50 animate-pulse"
          />
        </div>
      </div>
      <div className="flex items-center mt-4">
        <svg
          className="w-12 h-12 me-3 text-gray-300 "
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
        </svg>
        <div>
          <div className="h-4 bg-gray-200 rounded-full w-32  md:w-56 mb-2"></div>
          <div className="w-56 md:w-96 h-4 bg-gray-200 rounded-full "></div>
        </div>
      </div>
    </div>
  );
};

export default DetailsPageSkeliton;
